import { render, staticRenderFns } from "./SummaryOnBoardCrewPieChart.vue?vue&type=template&id=4b01e716&scoped=true&"
import script from "./SummaryOnBoardCrewPieChart.vue?vue&type=script&lang=js&"
export * from "./SummaryOnBoardCrewPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b01e716",
  null
  
)

export default component.exports